import hasAccess from './components/PopupHasAccess.vue'

export default {
	data: function() {
		return {
			itemStyle: null,
			licences: null,
			loaded: false,
			parent: null
		}
	},
	created: function () {
	  	window.addEventListener('resize', this.onResize)
	},
	beforeDestroy: function () {
	  	window.removeEventListener('resize', this.onResize)
	},
	methods: {
		onResize() {
			if (this.$refs.item) {
				let item = _.isArray(this.$refs.item) ? this.$refs.item[0] : this.$refs.item;
				this.itemStyle = {
					height: item.clientWidth + 'px'
				};
			} else if (this.$refs.add) {
				let add = this.$refs.add;
				this.itemStyle = {
					height: add.clientWidth + 'px'
				};
			}
		},
		iconPath(credit) {
			return 'url(images/icon_' + credit + '.png)';
		},
		loadLicences(slug, sortKey) {
			axios.get(this.route('api-licences'), {
				params: {
					slug: slug
				}
			}).then((response) => {
				this.loaded = true;
				let data = response.data;
				if (data.parent) this.parent = data.parent;
				if (_.isArray(data.items)) {
					let licences = data.items;
					if (sortKey) {
						licences = _.sortBy(licences, sortKey);
					}
					this.licences = licences;
					this.$nextTick(this.onResize);
				}
			});
		},
		buildUrl(licence) {
			return this.route('vsebine', licence.credit_id);
		},
		onClick(licence, confirm, $event) {
			if (licence.withinTimeRestriction && !confirm) {
				$event.preventDefault();
				this.$root.$emit('add-popup', hasAccess, {
					withinTimeRestriction: licence.withinTimeRestriction,
					hasAccess: licence.hasAccess,
					licence: licence,
					url: this.buildUrl(licence)
				});
			}
		},
	},
};


// WEBPACK FOOTER //
// ./resources/assets/js/library-item.js